// ======================================================================
// File Name       : groupUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export function createTree(groupList, isCheked, selectedGroupCheck, isDisabled) {
  const tree = [];
  const nodeMapper = {};
  if (groupList && groupList.length) {
    for (const group of groupList) {
      const arrElem = {
        id: group.groupSecernId, // DOM element id
        text: group.groupName,
        icon: false, // Item icon. If have, set same as icon in menu,
        data: {
          groupSecernId: group.groupSecernId,
          groupName: group.groupName,
          parentGroupSecernId: group.parentGroupSecernId,
          layer: group.layer,
        },
      };
      if (selectedGroupCheck) {
        if (isCheked) {
          arrElem.state = {
            checked:
            selectedGroupCheck &&
            selectedGroupCheck.indexOf(group.groupSecernId) > -1,
          };
          if (isDisabled) {
            arrElem.state = {
              checked:
              selectedGroupCheck &&
              selectedGroupCheck.indexOf(group.groupSecernId) > -1,
              disabled:
              selectedGroupCheck &&
              selectedGroupCheck.indexOf(group.groupSecernId) > -1,
            };
          }
        } else {
          arrElem.state = {
            selected:
            selectedGroupCheck &&
              group.groupSecernId === selectedGroupCheck.groupSecernId,
          };
        }
      }
      arrElem.parentGroupSecernId = group.parentGroupSecernId;
      arrElem.children = [];
      nodeMapper[group.groupSecernId] = arrElem;
    }

    for (const key in nodeMapper) {
      const node = nodeMapper[key];
      if (!node.parentGroupSecernId || !nodeMapper[node.parentGroupSecernId]) {
        tree.push(node);
      } else {
        nodeMapper[node.parentGroupSecernId].children.push(node);
      }
    }
  }

  return tree;
}
